import { render, staticRenderFns } from "./DigitalMenu.vue?vue&type=template&id=033051ef&scoped=true&"
import script from "./DigitalMenu.vue?vue&type=script&lang=js&"
export * from "./DigitalMenu.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMenu.vue?vue&type=style&index=0&id=033051ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033051ef",
  null
  
)

export default component.exports